<template>
  <generic-error no-appbar>
    <template v-slot:title>404</template>
    <h1>404</h1>
    <p>Désolé, la ressource n'existe pas.</p>
  </generic-error>
</template>

<script>
import GenericError from "./GenericError"
export default {
  components: {
    GenericError
  }
}
</script>

<style>
</style>
